import React, { useContext } from 'react';
import { EditorContext } from '../EditorContext';
import BinaryInput from './trackers/BinaryInput';
import FiverInput from './trackers/FiverInput';
import NumberInput from './trackers/NumberInput';
import TrafficLightInput from './trackers/TrafficLightInput';

interface MeasurementProps {
  last: boolean;
  subjectId: string;
  tracker: {
    id: string;
    type: TrackerType;
    name: string;
  };
}

const Measurement: React.FC<MeasurementProps> = ({ last = false, subjectId, tracker }) => {
  const { state, dispatch } = useContext(EditorContext);

  let displayValue;

  state.input.measurements.forEach(measurement => {
    if (measurement.subjectId === subjectId && measurement.trackerId === tracker.id) {
      displayValue = measurement.value;
    }
  });

  return (
    <div className={`ph3 pv2 bb ${last ? 'b--transparent' : 'b--light-gray'}`}>
      {tracker.type === 'BINARY' && (
        <BinaryInput
          name={tracker.name}
          value={displayValue}
          callback={value =>
            dispatch({
              type: 'updateMeasurements',
              subjectId,
              trackerId: tracker.id,
              value
            })
          }
        />
      )}
      {tracker.type === 'FIVER' && (
        <FiverInput
          name={tracker.name}
          value={displayValue}
          callback={value =>
            dispatch({
              type: 'updateMeasurements',
              subjectId,
              trackerId: tracker.id,
              value
            })
          }
        />
      )}
      {tracker.type === 'INTEGER' && (
        <NumberInput
          name={tracker.name}
          value={displayValue}
          callback={value =>
            dispatch({
              type: 'updateMeasurements',
              subjectId,
              trackerId: tracker.id,
              value
            })
          }
        />
      )}
      {tracker.type === 'TRAFFIC_LIGHT' && (
        <TrafficLightInput
          name={tracker.name}
          value={displayValue}
          callback={value =>
            dispatch({
              type: 'updateMeasurements',
              subjectId,
              trackerId: tracker.id,
              value
            })
          }
        />
      )}
    </div>
  );
};

export default Measurement;
